import {useQueries} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getFeedTemplates} from '../../../apis/feed/getFeedTemplates'
import {getFeedChannel} from '../../../pages/feed/constants'
import {feedTemplateToItem} from '../../../pages/feed/utils'
import {IFeedItem, IFeedTemplate} from '../../../pages/feed/types'

// 계약 kind 전체를 kind별로 병렬 조회한 뒤 현재 채널(language) 템플릿만 어드민 아이템으로 변환한다.
// 목록 API가 kind 단위라 kind마다 개별 쿼리를 돌린다(useQueries).
const useQueryFeedTemplates = (kinds: string[]) => {
    const channel = getFeedChannel()

    const queries = useQueries({
        queries: kinds.map(kind => ({
            queryKey: QueryCacheKeys.feed.getFeedTemplates(kind),
            queryFn: async () => {
                const {data} = await getFeedTemplates(kind)
                return (data || []) as IFeedTemplate[]
            },
            refetchOnWindowFocus: false,
        })),
    })

    const items: IFeedItem[] = queries
        .flatMap(query => query.data || [])
        .filter(template => template.language === channel)
        .map(feedTemplateToItem)

    const isLoading = queries.some(query => query.isLoading)
    const refetch = () => queries.forEach(query => query.refetch())

    return {items, isLoading, refetch}
}

export default useQueryFeedTemplates
